import Link from "next/link"
import MobileSidebarDrawer, { makeTagUrl } from "./MobileSidebarDrawer"

type TagsProps = {
  tag: string
  tags: Array<{ id: string; name: string }>
  search?: string
}

export function Tags({ tag, tags, search }: TagsProps) {
  return (
    <div className="flex flex-col gap-3 w-full lg:w-[225px] shrink-0">
      <h4 className="text-sm text-fg-secondary font-medium">
        Browse by category
      </h4>
      <MobileSidebarDrawer
        items={tags.map((tag) => ({
          id: tag.id,
          label: tag.name,
          href: makeTagUrl(tag.id, search),
        }))}
        selectedKey={tag}
      />
      <div className="hidden lg:flex flex-col gap-px flex-1">
        {tags.map((tagItem) => (
          <Link
            key={tagItem.id}
            href={makeTagUrl(tagItem.id, search)}
            scroll={false}
            className="tt-vertical-tab"
            data-selected={tagItem.id === tag || undefined}
          >
            {tagItem.name}
          </Link>
        ))}
      </div>
    </div>
  )
}
